<div class="flex justify-center items-center flex-col w-10/12 confirm-container mt-6 sm:mt-12 bg-gray-300 p-6" style="border-radius: 12px;">

  <mat-spinner
  *ngIf="loading"
  class="loading-spinner"
  [color]="color"
  [diameter]="diameter"
  >
  </mat-spinner>

  <div class="flex flex-col" *ngIf="!loading">

    <div class="bg-white flex flex-col justify-center items-center sm:pt-4 sm:pl-4 sm:pr-4 sm:pb-3 p-2" style="border-radius: 12px;">
      <div class="p-3">
        <img class="h-12" src='{{wallet.img}}'>
      </div>
      <div class="w-3/4 mb-2 sm:mb-6" style="border-bottom: 1px solid #c9c9c9;">
        <p class="text-center text-md">
          Are you sure you want to pay with your <span class="chosen-wallet-text uppercase font-bold">{{wallet.name}}</span> wallet? You will receive a USSD request to process and finalise this transaction.
        </p>
      </div>
      <button class="text-xl text-white font-medium border-solid rounded-lg continue-button py-2 sm:px-12 px-8" [ngStyle]="{'background-color': headerColor}" (click)="confirmWallet()">
        CONTINUE
      </button>

    </div>

    <button class="text-lg mt-2" [ngStyle]="{'color': headerColor}" (click)="goBackToWallet()">
      <strong>BACK TO WALLET SELECTION</strong>
    </button>

  </div>

</div>

<!-- TODO: Wallet img does not load because it is based on router, and reloading does not send the router -->

<!-- <div class="mt-10 w-full flex justify-center">

  <div class="wallet flex justify-center flex-col items-center">
    <p class="text-lg text-center">
      Select a wallet to pay with
    </p>

    <div class="flex flex-wrap justify-center w-10/12 items-center border-soft bg-gray-300 overflow-y-auto p-2 min-h-150 min-w-250" style="border-radius: 12px;">

      <mat-spinner
      *ngIf="loading"
      class="loading-spinner"
      [color]="color"
      [diameter]="diameter"
      >
      </mat-spinner>

      <span class="w-full flex flex-wrap justify-center" *ngIf="!loading">
      </span>

    </div>

  </div>
</div> -->
